// Global client configuration
// This file contains version information and other client constants

import { isProduction } from "~/lib/env";

/**
 * Name of the session cookie the backend sets. Non-production backends suffix it with
 * `_non_prod` (backend `get_cookie_params`), so the client MUST read the environment-matching
 * name. Hardcoding the production name made every non-prod visit see no session after a
 * successful `create_account`, closing the gate with `SESSION_UNAVAILABLE` on staging while
 * production worked.
 */
export const SESSION_COOKIE_NAME = isProduction ? "blidz_session_id" : "blidz_session_id_non_prod";

export const CLIENT_CONFIG = {
  // Client version sent to backend in x-blidz-client-version header
  VERSION: "100.0.0",

  // Terms and conditions version for API calls
  TERMS_VERSION: 6,

  // Other client constants can be added here
  APP_NAME: "Blidz Web",
  PLATFORM: "web",
} as const;

export default CLIENT_CONFIG;
